module.exports = __webpack_public_path__ + "static/media/OTR-Image.1fef4c4a.png";